import Modal from "react-responsive-modal";
import { useState, ReactElement } from "react";
import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";

type Props = {
  id: number;
  titulo: string;
  descricao: string;
  inicio: Date;
  fim: Date;
  link: string;
};

const RowColaboracoes = (colaboracaoObj: Props) => {
  const [openModal, setModal] = useState(false);
  const navigate = useNavigate();
  return (
    <tr className={styles.row}>
      <td>{colaboracaoObj.titulo}</td>
      <td>{colaboracaoObj.descricao}</td>
      <td className={styles.prazo}>
        {`${new Date(colaboracaoObj.inicio).toLocaleDateString()} à ${new Date(colaboracaoObj.fim).toLocaleDateString()}`}
      </td>
      <td>
        <button className={styles.viewButton} onClick={(e) => {
          e.preventDefault();
          navigate(`${colaboracaoObj.id}`, { state: colaboracaoObj })
        }}>Visualizar</button>
        <Modal
          open={openModal}
          onClose={() => setModal(false)}
          center
          classNames={{
            modal: "customModal",
          }}
        >
          
        </Modal>
      </td>
    </tr>
  );
};
export default RowColaboracoes;
